import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux'; 
import Layout from '../Layout';
import '../../../global.css';
import { useNavigate, Link } from 'react-router-dom';
import Back from '../../../components/common/Back';
import nextSvg from '../../../images/next.svg';
import api from '../../../api';
import {deleteCookie} from '../../../utils';
import { logout } from '../../../redux/slices/protectSlice';
import CancelSubscriptionMessageModal from './CancelSubscriptionMessageModal';

const Configuration = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { planActive, userType } = useSelector((state) => state.apiResponses);
  const [isCancelModalOpen, setIsCancelModalOpen] = useState(false);

  const closeCancelModal = () => {
    setIsCancelModalOpen(false);
  };

  const openCancelModal = () => {
    setIsCancelModalOpen(true);
  };

  const handleLogout = async () => {
    try {
      const response = await api.post(`${process.env.REACT_APP_API_BASE_URL}/logout`, {}, {});
      deleteCookie('accessToken');
      if (response.data.status === 'Success') {
        localStorage.removeItem('token');
        dispatch(logout());
        navigate('/login');
      } else {
      }
    } catch (error) {
    }
  };

  return (
    <Layout>
      <main className="main" style={{ overflow: 'unset' }}>
        <div className="card-entries mt-3">
          <header className="main-head flex justify-between align-center">
            <h1 className="greet-user-text">Configurations</h1>
            <div className="ms-auto">
              <Back />
            </div>
          </header>
          <div className="main-content flex justify-between flex-col-rev-mob">
            <div className="phases-container" style={{minHeight:'unset'}}>
              <div className="tab-content-info" id="tab4">
                <div className="tab-content-info-title">
                  <h2>My Account</h2>
                </div>
                <ul>
                  {planActive && (
                  <li>
                    <Link to="/profile">
                      <img
                        src={nextSvg}
                        alt="Profile"
                      />
                      <span>Update Personal Information & Goals</span>
                    </Link>
                  </li>
                  )}

                  {planActive && (
                  <li>
                    <Link to="/change-password">
                      <img
                        src={nextSvg}
                        alt="Change Password"
                      />
                      <span>Change Password</span>
                    </Link>
                  </li>
                  )}

                  {userType == '2' && (
                   <li>
                    <Link onClick={openCancelModal}>
                      <img
                        src={nextSvg}
                        alt="Subscription"
                      />
                      <span>Subscription</span>
                    </Link>
                  </li>
                  )}

                  {planActive && (
                  <li>
                    <Link to="/invite-user">
                      <img
                        src={nextSvg}
                        alt="Invite User"
                      />
                      <span>Invite User</span>
                    </Link>
                  </li>
                  )}
                  <li>
                    <Link onClick={handleLogout}>
                      <img
                        src={nextSvg}
                        alt="Logout"
                      />
                      <span>Logout</span>
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </main>

      <CancelSubscriptionMessageModal isOpen={isCancelModalOpen} onClose={closeCancelModal} />

    </Layout>
  );
};

export default Configuration;